import { apiPut } from "../baseApi";
import { setBuildingData } from "service/mapper";

export const update = async (data, id) => {
  try {
    const response = await apiPut("_building", id, data);
    return { ...response, data: setBuildingData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
